
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class CPAlertsSummary extends Vue {

  public close() {
    this.$store.commit('toggleAlerts', false);
  }

  public mounted() {
    this.$store.dispatch('getAlerts');
  }
}
